import { Injectable } from '@angular/core';
import { UserProfileConnector as CxUserProfileConnector } from '@spartacus/user/profile/core';
import { Observable } from 'rxjs';
import { Credentials, NameInputCheckResult, User, UserInputCheck, UserSignUp } from '../../model';
import { UserProfileAdapter } from './user-profile.adapter';

@Injectable({
  providedIn: 'root',
})
export class UserProfileConnector extends CxUserProfileConnector {
  constructor(protected userProfileAdapter: UserProfileAdapter) {
    super(userProfileAdapter);
  }

  load(userId: string): Observable<User> {
    return this.userProfileAdapter.load(userId);
  }

  update(userId: string, user: User): Observable<{}> {
    return this.userProfileAdapter.update(userId, user);
  }

  register(user: UserSignUp): Observable<User> {
    return this.userProfileAdapter.register(user);
  }

  requestForgotPasswordEmail(userEmailAddress: string, username?: string): Observable<{}> {
    return this.userProfileAdapter.requestForgotPasswordEmail(userEmailAddress, username);
  }

  resetPassword(token: string, newPassword: string): Observable<{}> {
    return this.userProfileAdapter.resetPassword(token, newPassword);
  }

  requestForgotUsernameEmail(userEmailAddress: string): Observable<{}> {
    return this.userProfileAdapter.requestForgotUsernameEmail(userEmailAddress);
  }

  updateCredentials(userId: string, credentials: Credentials): Observable<{}> {
    return this.userProfileAdapter.updateCredentials(userId, credentials);
  }

  remove(userId: string, password?: string): Observable<{}> {
    return this.userProfileAdapter.remove(userId, password);
  }

  validateUserEmail(userId: string, email: string): Observable<UserInputCheck> {
    return this.userProfileAdapter.validateUserEmail(userId, email);
  }

  checkDuplicatedUsername(username: string): Observable<UserInputCheck> {
    return this.userProfileAdapter.checkDuplicatedUsername(username);
  }

  validateName(name: string): Observable<NameInputCheckResult> {
    return this.userProfileAdapter.validateName(name);
  }

  changeCustomerSessionLanguage(userId: string, languageCode: string): Observable<any> {
    return this.userProfileAdapter.changeCustomerSessionLanguage(userId, languageCode);
  }
}
